
import { setSocketData } from "../../redux/socket-data-slice";
import { store } from "../../redux/store";
import { JwtAuthService } from "../authentication";
import { SocketService } from "./socket.service";

interface SocketInit {
    name: string;
    init: boolean;
}

export class FabrixSocketsService {

    private static _instance: FabrixSocketsService;
    private initIndex = new Array<SocketInit>();


    private constructor() {

    }

    public static get instance(): FabrixSocketsService {
        if (!FabrixSocketsService._instance) {
            FabrixSocketsService._instance = new FabrixSocketsService();
        }

        return FabrixSocketsService._instance;

    }

    public onEvent?: (name: string, eventName: string, payload: any) => void;

    private isInit(name: string) {
        let item = this.initIndex.find(x => x.name === name)
        if (item)
            return item.init;
        return false;
    }

    private initItem(name: string, value: boolean) {
        let index = this.initIndex.findIndex(x => x.name === name)
        if (index !== -1)
            this.initIndex[index].init = true;
        else
            this.initIndex.push({ name: name, init: value })
    }


    public init(name: string, eventNames: string[]) {


        if (!this.isInit(name) && JwtAuthService.isAuthenticated()) {


            for (let eventName of eventNames) {

                SocketService.getSocket(name, eventName).then(_socket => {
                    if (_socket) {
                        _socket.off(eventName);
                        _socket.on(eventName, async (data: any) => {
                            // console.log(`Socket event received: ${eventName}`, data);
                            store.dispatch(setSocketData({ eventName: eventName, data: data }))
                            if (this.onEvent) {
                                this.onEvent(name, eventName, data)
                            }
                        });
                        this.initItem(name, true)
                    }
                });
            }

        }
    }

    public resetSockets(name: string) {
        this.initItem(name, false)
        SocketService.reset(name);
    }
}









